/* Buscador de funcionarios activos (nombre, cédula o legajo) del módulo de
 * Agendamientos (TD-11766). Al elegir uno llama a onElegir y se limpia. */
import { TextField } from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { useEffect, useRef, useState } from "react";
import AgendaAPI, { Funcionario } from "src/services/agenda";

interface Props {
  label: string;
  onElegir: (f: Funcionario) => void;
  helperText?: string;
  size?: "small" | "medium";
}

const AgendaBuscadorFuncionario: React.FC<Props> = ({ label, onElegir, helperText, size = "medium" }) => {
  const [texto, setTexto] = useState("");
  const [opciones, setOpciones] = useState<Funcionario[]>([]);
  const [cargando, setCargando] = useState(false);
  const pedido = useRef(0);

  useEffect(() => {
    const q = texto.trim();
    if (q.length < 3 && !/^\d+$/.test(q)) {
      pedido.current++; // invalida una búsqueda en vuelo: su respuesta ya no aplica
      setOpciones([]);
      setCargando(false);
      return;
    }
    const n = ++pedido.current;
    const timer = window.setTimeout(async () => {
      setCargando(true);
      try {
        const res = await AgendaAPI.buscarFuncionarios(q);
        // Descarta respuestas viejas si el usuario siguió escribiendo.
        if (n === pedido.current) setOpciones(res);
      } catch {
        if (n === pedido.current) setOpciones([]);
      } finally {
        if (n === pedido.current) setCargando(false);
      }
    }, 350);
    return () => window.clearTimeout(timer);
  }, [texto]);

  return (
    <MuiAutocomplete
      options={opciones}
      loading={cargando}
      value={null}
      inputValue={texto}
      filterOptions={(x) => x}
      getOptionLabel={(f) => `${f.nombre} (${f.cedula})`}
      renderOption={(f) => (
        <div>
          <div>{f.nombre}</div>
          <small style={{ color: "#6b7280" }}>
            C.I. {f.cedula}
            {f.cargo ? ` · ${f.cargo}` : ""}
          </small>
        </div>
      )}
      noOptionsText={texto.trim().length < 3 ? "Escribí al menos 3 letras o un número" : "Sin coincidencias"}
      loadingText="Buscando..."
      onInputChange={(_, val, motivo) => {
        if (motivo !== "reset") setTexto(val);
      }}
      onChange={(_, f) => {
        if (f) {
          onElegir(f);
          setTexto("");
          setOpciones([]);
        }
      }}
      renderInput={(params) => (
        <TextField {...params} size={size} variant="outlined" label={label} helperText={helperText} />
      )}
    />
  );
};

export default AgendaBuscadorFuncionario;
